import { GlTruncate, GlIcon, GlTooltipDirective, GlButton } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
import FileIcon from './file_icon.vue?vue3';
export default {
    name: 'FileRow',
    components: {
        FileIcon,
        GlTruncate,
        GlIcon,
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        file: {
            type: Object,
            required: true
        },
        level: {
            type: Number,
            required: true
        },
        showTreeToggle: {
            type: Boolean,
            required: false,
            default: false
        },
        // Should be set to true if parent handles focus management (ARIA treeview pattern)
        rovingTabindex: {
            type: Boolean,
            required: false,
            default: false
        },
        boldText: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: [
        'click-file',
        'click-row',
        'click-submodule',
        'click-tree',
        'show-more',
        'toggle-tree'
    ],
    computed: {
        isTree () {
            return this.file.type === 'tree';
        },
        isBlob () {
            return this.file.type === 'blob';
        },
        fileClass () {
            const addFilePadding = !this.isTree && this.showTreeToggle;
            return {
                'file-open': this.isBlob && this.file.opened,
                'is-active': this.isBlob && this.file.active,
                folder: this.isTree,
                'is-open': this.file.opened,
                '!gl-bg-feedback-info': this.file.linked,
                '!gl-pl-5': addFilePadding
            };
        },
        textForTitle () {
            // don't output a title if we don't have the expanded path
            return this.file?.tree?.length ? this.file.tree[0].parentPath : false;
        },
        chevronIcon () {
            return this.file.opened ? 'chevron-down' : 'chevron-right';
        },
        chevronAriaLabel () {
            const action = this.file.opened ? __('Collapse %{name} directory') : __('Expand %{name} directory');
            return sprintf(action, {
                name: this.file.name
            });
        },
        buttonTabindex () {
            return this.rovingTabindex ? -1 : 0;
        },
        fileRowContainerClassList () {
            // Left position: (1.5rem button / 2) - (1px line / 2)
            return {
                'before:!gl-left-[calc(0.75rem-0.5px)]': this.showTreeToggle
            };
        }
    },
    methods: {
        clickFile (event) {
            // allow opening in new tab with ctrl/cmd and click
            // without opening in current tab
            if (this.file.href && (event.ctrlKey || event.metaKey)) {
                return;
            }
            this.$emit('click-row', event);
            if (this.isTree) {
                this.$emit('click-tree', event);
            } else if (this.file.submodule) {
                this.$emit('click-submodule', event);
            } else if (this.isBlob) {
                this.$emit('click-file', event);
            }
            if (this.file.href) {
                event.preventDefault();
            }
        }
    }
};
